import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { Table, Input, Button,Card } from 'antd';
import { PrinterOutlined, FileExcelOutlined, FilterOutlined } from '@ant-design/icons';
import '../listacontador.css';
import { ComponentToPrint } from './Print';
import ReactToPrint from 'react-to-print';
import ReactToExcel from 'react-html-table-to-excel';

function ListaContador() {
  const [Cliente, setClientes] = useState([]);
  const [total, setTotal] = useState(null);
  const Listameters = useRef();
  const [dado, setDado] = useState('');
  const [dados, setDados] = useState('');
  const [error, setError] = useState();

  useEffect(() => {
    axios({
      method: 'post',
      url: `${localStorage.getItem('url')}/web/todosContadores/`,
      headers: {
        Authorization: `token ${localStorage.getItem('token')}`,
        'Content-Type': 'application/json'
      },
      data: { id: 'sds' }
    })
      .then((dat) => {
        if (dat.status !== 200) {
          throw Error('Dados de acesso invalidos');
        }
        return dat;
      })
      .then((df) => {
        setClientes(df.data);
      })
      .catch((e) => {
        setError(e.message);
      });

    axios({
      method: 'post',
      url: `${localStorage.getItem('url')}/web/ctotais/`,
      headers: {
        Authorization: `token ${localStorage.getItem('token')}`,
        'Content-Type': 'application/json'
      },
      data: { id: 'sds' }
    })
      .then((dat) => {
        if (dat.status !== 200) {
          throw Error('Dados de acesso invalidos');
        }
        return dat;
      })
      .then((df) => {
        setTotal(df.data);
      })
      .catch((e) => {
        setError(e.message);
      });
  }, []);

  const handleDadoChange = (e) => {
    setDado(e.target.value);
  };

  const handleDadosChange = (e) => {
    setDados(e.target.value);
  };

  const columns = [
    {
      title: 'id',
      dataIndex: 'idContador',
      key: 'idContador'
    },
    {
      title: 'Numero do Contador',
      dataIndex: 'numero_do_contador',
      key: 'numero_do_contador',
      filterIcon: <FilterOutlined />,
      filterDropdown: (
        <div style={{ padding: 8 }}>
          <Input
            placeholder="Search Numero do Contador"
            value={dado}
            onChange={handleDadoChange}
            style={{ width: 188, marginBottom: 8, display: 'block' }}
          />
        </div>
      ),
      filteredValue: [dado],
      onFilter: (value, record) =>
        record.numero_do_contador.toLowerCase().includes(value.toLowerCase())
    },
    {
      title: 'Estado',
      dataIndex: 'estado',
      key: 'estado',
      filterIcon: <FilterOutlined />,
      filterDropdown: (
        <div style={{ padding: 8 }}>
          <Input
            placeholder="Search Estado"
            value={dados}
            onChange={handleDadosChange}
            style={{ width: 188, marginBottom: 8, display: 'block' }}
          />
        </div>
      ),
      filteredValue: [dados],
      onFilter: (value, record) => record.estado.toLowerCase().includes(value.toLowerCase())
    }
  ];
  

  return (
    <div className="Tabela">
    
      {total && (
        <div className="Totais" style={{marginTop:'2%',marginBottom:'2%'}}>
          <Card>
            <span>Total: {total.total}</span>
          </Card>
          <Card>
            <span>Instalados: {total.instalados}</span>
          </Card>
          <Card>
            <span>Em Stock: {total.stock}</span>
          </Card>
          <Card>
            <span>Defeituosos: {total.defeituoso}</span>
          </Card>
        </div>
      )}
      <div >
        <Table
          dataSource={Cliente}
          columns={columns}
          pagination={{ pageSize: 4 }}
        />
      </div>
     

    </div>
  );
}

export default ListaContador;
